













































































































































import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindVendaUseCase } from '@/usecases'
import printJS from 'print-js'
import { Component, Vue } from 'vue-property-decorator'

interface Venda {
	identificador: string
	nomeLoja: string
	numeroNota: string
	serieNota: string
	tipoDeTransacao: string
	chaveNfceGerada: string
	vendaId: string
}

@Component({
	components: {},
})
export default class DialogoDeBuscarCuponsDeVendas extends Vue {
	mostra = false
	identificadorVenda = ''
	vendas: Venda[] = []
	carregando = false
	erroMensagem = ''
	carregarImpressao = false
	tipoDeFiltroSelecionado = 'identificadorExterno'

	findVendaUseCase = new FindVendaUseCase()

	headers = [
		{ text: 'Identificador', value: 'identificador', sortable: false },
		{ text: 'Loja', value: 'nomeLoja', sortable: false },
		{ text: 'Nº Nota', value: 'numeroNota', sortable: false },
		{ text: 'Série', value: 'serieNota', sortable: false },
		{ text: 'Tipo de Transação', value: 'tipoDeTransacao', sortable: false },
		{ text: 'Ações', value: 'acoes', sortable: false, align: 'center', width: '80' },
	]

	mostrar() {
		this.mostra = true
		this.identificadorVenda = ''
		this.erroMensagem = ''
	}

	esconder() {
		this.mostra = false
	}

	limpar(){
		localStorage.removeItem('FILTRO_DE_VENDA_MULTIPLO_CUPOM');
		this.vendas = []
	}

	async buscarVenda() {
		if (!this.identificadorVenda) {
			this.erroMensagem = 'Digite um identificador válido'
			return
		}

		if (this.vendas.some(v => v.identificador === this.identificadorVenda)) {
			this.erroMensagem = 'Esta venda já foi adicionada'
			return
		}

		this.carregando = true
		this.erroMensagem = ''

		try {

			const nova = await this.findVendaUseCase.find({ [this.tipoDeFiltroSelecionado] : this.identificadorVenda})

			if(nova.content[0].notas.filter(n => n.modelo === 'NFC-e').length < 1){
				this.erroMensagem = 'Não foram encontradas informações sobre o cupom'
				return
			}

			if(nova.content[0].notas.filter(n => n.cstat === '100').length < 1){
				this.erroMensagem = 'A venda deve conter status 100 na NFC-e para impressão do cupom'
				return
			}

			const temNfce = nova.content[0].notas.some(n => n.modelo === 'NFC-e')

			if (!temNfce) {
				this.erroMensagem = 'Necessario ser uma venda com NFC-e para impressão do cupom'
				return
			}

			if (nova.content[0].possuiNotaNaoEletronica) {
				this.erroMensagem = 'Necessario ser uma venda com NFC-e para impressão do cupom'
				return;
			}
				

			const novaVenda: Venda = {
				identificador: this.identificadorVenda,
				nomeLoja: nova.content[0].pontoDeVenda && 
					nova.content[0].pontoDeVenda.loja.nome !== null ? 
					nova.content[0].pontoDeVenda?.loja.nome : '',
				numeroNota: nova.content[0].notas ? nova.content[0].notas[0].nnf : '',
				serieNota:nova.content[0].notas ? nova.content[0].notas[0].serie : '',
				tipoDeTransacao: nova.content[0].notas ? nova.content[0].tipoDeTransacao : '',
				chaveNfceGerada: nova.content[0].notas ? nova.content[0].notas[0].chNFe : '',
				vendaId: nova.content[0].id,
			}

			this.vendas.push(novaVenda)
			const jsonVenda = JSON.stringify(this.vendas);
			localStorage.setItem('FILTRO_DE_VENDA_MULTIPLO_CUPOM', jsonVenda)

			this.identificadorVenda = ''
		} catch (error) {
			this.erroMensagem = 'Venda não encontrada'
		} finally {
			this.carregando = false
		}
	}

	removerVenda(identificador: string) {
		this.vendas = this.vendas.filter(v => v.identificador !== identificador)
	}

	async imprimir() {
		this.carregarImpressao = true

		try {
			const response = await this.findVendaUseCase.imprimirMultiplosCupons(
				this.vendas.map(venda => venda.vendaId),
			);

			imprimePdf(response, this.vendas[0].vendaId)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregarImpressao = false
			this.limpar()			
		}
	}

	created() {
		const vendasSalvas = localStorage.getItem('FILTRO_DE_VENDA_MULTIPLO_CUPOM');
		this.vendas = vendasSalvas ? JSON.parse(vendasSalvas) : [];
	}
}

function imprimePdf(response: any, nomeDoArquivo: string) {
	const blob = new Blob([response], { type: 'application/pdf' })
	const url = window.URL.createObjectURL(blob)

	return Promise.race([
		new Promise<void>((resolve, reject) => {
			printJS({
				printable: url,
				type: 'pdf',
				documentTitle: `${nomeDoArquivo}.pdf`,
				onError: error => reject(error),
				onLoadingEnd: () => {
					resolve()
					window.URL.revokeObjectURL(url)
				},
			})
		}),
		new Promise((_, reject) =>
			setTimeout(
				() => reject('Erro ao gerar impressão, verifique as configurações'),
				15000,
			),
		),
	])
}
